// extracted by mini-css-extract-plugin
export default {"uploadButtonsContainer":"file-upload-buttons_uploadButtonsContainer__Z92Zn","uploadButton":"file-upload-buttons_uploadButton__Yp+nB"};